import { ContainerHeader, LinkApi } from "./styles";


export default function Header() {
    return (
        <ContainerHeader>
            <h1>Integração de APIs I - </h1>
            <LinkApi href="https://documenter.getpostman.com/view/7549981/SzfCT5G2#intro" target="_blank" rel="noreferrer">API Labenusers</LinkApi>
        </ContainerHeader>

    )

}